export const SET_USER = 'SET_USER';



// WEBPACK FOOTER //
// ./src/pages/auth/store/mutations-types.js